document.addEventListener('DOMContentLoaded', () => {
  const sidebarRefurbishmentOpen = document.querySelector('.refurbishment-process-footer-button');
  if (sidebarRefurbishmentOpen) {
    sidebarRefurbishmentOpen.addEventListener('click', (e) => {
      e.stopPropagation();
      const sidebarOpen = document.getElementById('sidebar-cart-open');
      if (sidebarOpen) {
        sidebarOpen.click();

        const cartSidebar = document.querySelector('#cart-sidebar');
        const refurbishedList = cartSidebar.querySelector('#refurbished-list-wrp');
        const accessoriesList = cartSidebar.querySelector('.accessories-list.refurbished');
        if (accessoriesList && refurbishedList) {
          refurbishedList.classList.add('open');
          accessoriesList.style.display = 'block';
        }
      }
      document.body.classList.add('sidebar-open');
    });
  }
});
